export default __webpack_public_path__ + "static/media/Path2744.740edd18.svg";